<template>
  <div class="container">

    <h2 class="text-center text-white"> {{ title }}</h2>

    <nav>
      <ol class="breadcrumb justify-content-center mt-4">
        <li class="breadcrumb-item">
          <router-link to="/home">首页</router-link>
        </li>
        <li class="breadcrumb-item active" aria-current="page">{{ title }}</li>
      </ol>
    </nav>

  </div>
</template>

<script>
export default {
  name: 'TitAndBread',
  components: {},
  props: {},
  data() {
    return {
      title: ''
    }
  },
  mounted() {
    this.title = this.$route.meta.title;
   },
  methods: {}
}
</script>

<style scoped lang="less"></style>
